import { FC, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import styled from 'styled-components'
import { Box, Flex } from '@/components/atoms/Grid'
import { Capitalized } from '@/components/atoms/typography'
import { NextArrowIconDefault } from '@/components/atoms/icons/NextArrowIconDefault'
import {
  ContactService,
  ContactServiceOption
} from '@/components/organisms/contact/contactServiceData'
import { validFor } from '@/theme/validFor'
import { useDomain } from '@/providers/storeProvider'

type ContactServiceProps = {
  service: ContactService
}

const ContactServiceBox: FC<ContactServiceProps> = ({ service }) => {
  const { t } = useTranslation('common')

  const [showContact, setShowContact] = useState<boolean>(true)

  const { domainName } = useDomain()

  const contactTime = `Footer.Contact.time_${domainName}`

  const contactData = `Footer.Contact.${service.type}_${domainName}`

  const handleContact = () => {
    setShowContact(false)
  }

  return (
    <ServiceWrapper key={service.id}>
      <Box pt={2}>{service.IconElement}</Box>
      <Flex flexDirection="column" textAlign="center">
        <Box>{t(service.title)}</Box>
        {service.id === ContactServiceOption.Phone && t(contactTime)}
      </Flex>
      <ShowContact onClick={handleContact}>
        <Box />
        <Capitalized>
          {showContact ? t(service.text) : t(contactData)}
        </Capitalized>
        <NextArrowIconDefault width={14} height={14} />
      </ShowContact>
    </ServiceWrapper>
  )
}

export default ContactServiceBox

const ServiceWrapper = styled(Flex)`
  width: 280px;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
  ${validFor.mobile` 
 
    justify-content: center;
	`};
`
const ShowContact = styled(Flex)`
  background-color: ${(props) => props.theme.colors.mobileBackground};
  justify-content: space-between;
  margin-top: 10px;
  &:hover {
    cursor: pointer;
  }
`
